import * as React from 'react'
import { Button, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import Widget from '../../../components/Widget'
import { UprightStyle } from '../../../types'
import { NavigationProps } from './types'
import { VALID_POLL_STATUSES } from './constants'
import ListingStates from '../../../constants/listings/ListingStates'

const styles: UprightStyle = {
  queueControl: {
    marginTop: 20,
    position: 'sticky',
    top: -45,
    zIndex: 2
  }
}

export const Navigation = ({
  index,
  total,
  onPrevious,
  onNext,
  isSummaryPage,
  onSave,
  backToListings,
  listingState,
  onSaveAndList,
  isLoading,
  onCancel,
  isEditing,
  hideActionButtons
}: NavigationProps): JSX.Element => (
  <Widget title="Review Pending Listings" style={styles.queueControl}>
    <div className="queue-wrapper">
      <div className="queue-controller">
        <Button
          onClick={onPrevious}
          minimal
          icon={IconNames.CHEVRON_LEFT}
          className="previous"
          disabled={index === 0 && !isSummaryPage}
        >
          Previous
        </Button>
        <div className="queue-info">{isSummaryPage ? 'Review Complete' : `Reviewing ${index + 1} of ${total}`}</div>
        <Button onClick={onNext} minimal rightIcon={IconNames.CHEVRON_RIGHT} disabled={isSummaryPage}>
          Next
        </Button>
      </div>
      {!hideActionButtons && (
        <div className="action-buttons">
          {!isSummaryPage &&
            ![ListingStates.LISTED.id, ListingStates.MODIFY_FAILED.id, ListingStates.MODIFYING.id].includes(
              listingState
            ) && (
              <>
                <Button
                  onClick={onSave}
                  intent={Intent.PRIMARY}
                  minimal
                  className="save"
                  disabled={VALID_POLL_STATUSES.includes(listingState)}
                  loading={isLoading}
                >
                  Save
                </Button>
                <Button
                  onClick={onSaveAndList}
                  intent={Intent.PRIMARY}
                  disabled={VALID_POLL_STATUSES.includes(listingState)}
                  loading={isLoading}
                >
                  Save and {listingState === ListingStates.RELISTING_FAILED.id ? 'relist' : 'list'}
                </Button>
              </>
            )}
          {!isSummaryPage &&
            [ListingStates.LISTED.id, ListingStates.MODIFY_FAILED.id, ListingStates.MODIFYING.id].includes(
              listingState
            ) && (
              <>
                <Button
                  onClick={onCancel}
                  intent={Intent.PRIMARY}
                  minimal
                  className="save"
                  disabled={VALID_POLL_STATUSES.includes(listingState)}
                  loading={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  onClick={onSaveAndList}
                  intent={Intent.PRIMARY}
                  disabled={
                    VALID_POLL_STATUSES.includes(listingState) ||
                    (!isEditing && listingState === ListingStates.LISTED.id)
                  }
                  loading={isLoading}
                >
                  Save listing
                </Button>
              </>
            )}
          {isSummaryPage && (
            <Button onClick={backToListings} intent={Intent.PRIMARY}>
              Back to Listings
            </Button>
          )}
        </div>
      )}
    </div>
  </Widget>
)
